import { ChannelPreviewUIComponentProps, useChatContext } from 'stream-chat-react';
import { Channel } from 'stream-chat';
import { CustomPreviewMessenger } from './CustomPreviewMessenger';

type Props = ChannelPreviewUIComponentProps & {
  onChannelSelect?: (channel: Channel) => void;
};

export const CustomChannelPreview = ({ onChannelSelect, ...props }: Props) => {
  const { setActiveChannel } = useChatContext();
  const { channel, lastMessage } = props;

  const handleSelect = () => {
    setActiveChannel(channel);
    onChannelSelect?.(channel);
  };

  return <CustomPreviewMessenger {...props} message={lastMessage} onSelect={handleSelect} />;
};
